import React from 'react';
import { Mail, Phone, MapPin } from 'lucide-react';
import T from './T';

const Footer: React.FC  = () => {
  return (
    <>
      <footer className="bg-[var(--color-bg-primary)] py-6 transition-colors duration-300">
        <div className="container mx-auto px-6">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="text-sm text-gray-600 dark:text-[var(--color-text-secondary)] mb-4 md:mb-0">
              <p className='text-center md:text-left'>
              © {new Date().getFullYear()} <T k="footer.copyright" />
              </p>
            </div>
            <div className="flex flex-col md:flex-row space-y-2 md:space-y-0 md:space-x-6">
              <a href="mailto:personal@pfjacobs.com" className="flex items-center space-x-2">
                <Mail className="w-4 h-4 text-[var(--color-text-primary)]" />
                <span className="text-sm text-[var(--color-text-secondary)] hover:underline">personal@pfjacobs.com</span>
              </a>
              <div className="flex items-center space-x-2">
                <Phone className="w-4 h-4 text-[var(--color-text-primary)]" />
                <span className="text-sm text-[var(--color-text-secondary)]">+31 617974012</span>
              </div>
              <div className="flex items-center space-x-2">
                <MapPin className="w-4 h-4 text-[var(--color-text-primary)]" />
                <span className="text-sm text-[var(--color-text-secondary)]"><T k="footer.location" /></span>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;